import { parse, format, isBefore, isAfter, isValid, compareAsc, compareDesc } from 'date-fns';
export class DateUtilsService {
   private static INVALID_DATE = 'Invalid Date' as const;
   private static APP_DATE_FORMAT = 'dd.MM.yyyy' as const;

   static formatEmployerDate(dateString: string): string {
      const date = new Date(dateString);

      if (date.toString() === DateUtilsService.INVALID_DATE) {
         throw Error('Date utils service: Not valid date');
      }
      const result = Intl.DateTimeFormat('uk-UA', {
         dateStyle: 'short',
         timeStyle: 'short',
      }).format(date);
      return result;
   }

   static toAppFormat(dateString: string): string {
      return format(new Date(dateString), DateUtilsService.APP_DATE_FORMAT);
   }

   static fromUnixToAppFormat(unix: string): string {
      return format(new Date(Number(unix)), 'dd.MM.yyyy');
   }

   static checkIsAfter(sourceDateString: string, pickDateString: string): boolean {
      const sourceDate = parse(sourceDateString, DateUtilsService.APP_DATE_FORMAT, new Date());
      const pickDate = parse(pickDateString, DateUtilsService.APP_DATE_FORMAT, new Date());
      return isAfter(sourceDate, pickDate);
   }

   static checkIsBefore(sourceDateString: string, pickDateString: string): boolean {
      const sourceDate = parse(sourceDateString, DateUtilsService.APP_DATE_FORMAT, new Date());
      const pickDate = parse(pickDateString, DateUtilsService.APP_DATE_FORMAT, new Date());
      return isBefore(sourceDate, pickDate);
   }

   static isValidDate(val: string): boolean {
      const date = parse(val, DateUtilsService.APP_DATE_FORMAT, new Date());
      return isValid(date);
   }

   static toUnix(val: string): string {
      const date = parse(val, 'MMM d, yyyy', new Date());
      return date.getTime().toString();
   }

   static compare(direction: 'asc' | 'desc', val1: string, val2: string): number {
      const date1 = parse(val1, DateUtilsService.APP_DATE_FORMAT, new Date());
      const date2 = parse(val2, DateUtilsService.APP_DATE_FORMAT, new Date());
      if (direction === 'asc') {
         return compareAsc(date1, date2);
      } else {
         return compareDesc(date1, date2);
      }
   }
}
